import usePureState from '@/hooks/use-pure-state';
import { useSetIntercomIsVisible } from '@/queries/layout.queries';
import { useEffect } from 'react';

type UseIntroWizardArgs = {
  onFinish: () => void;
};

export default function useIntroWizard(args: UseIntroWizardArgs) {
  const mutateIntercomIsVisible = useSetIntercomIsVisible();
  const { state, setPartialState } = usePureState({
    totalStepsNumber: 6,
    activeStep: 0,
  });

  useEffect(() => {
    mutateIntercomIsVisible.mutateAsync(false);
    return () => {
      mutateIntercomIsVisible.mutateAsync(true);
    };
  }, []);

  function handleNextButtonClick() {
    setPartialState({ activeStep: state.activeStep + 1 });

    if (state.activeStep === state.totalStepsNumber - 1) {
      return args.onFinish();
    }
  }

  function handleBackButtonClick() {
    setPartialState({ activeStep: state.activeStep - 1 });
  }

  return {
    activeStep: state.activeStep,
    activeStepIndex: state.activeStep - 1,
    buttonText: 'Next',
    handleBackButtonClick,
    handleNextButtonClick,
    numberOfSteps: state.totalStepsNumber - 1,
  };
}
